module.exports = __webpack_public_path__ + "static/media/more_horizontal_light.cb3ff692.svg";